<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md header="Devices">
    <sbnb-devices-subnav [demo]="true"></sbnb-devices-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" style="padding: 0px; margin-bottom: 0">
    <div
      class="demo-callout rules__intro-text"
      fxLayout
      fxLayoutAlign="start start"
      fxLayoutGap="24px"
      fxLayout.lt-sm="column"
      fxLayoutAlign.lt-sm="center center">
      <div fxFlex fxFlexOrder.lt-md="2">
        <h2>Connect smart home devices to {{ 'CORE.PRODUCT_NAME' | transloco }}</h2>
        <p class="notification__description">Save time managing your smart devices with Hospitable.</p>

        <p class="notification__description">
          Automate creating and sending smart lock codes, control property temperatures with thermostat presets, monitor
          device usage, view battery status, and more, all in one place.
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="0px">
          <sbnb-device-upsell-button>
            <a *sbnbDeviceUpsellButtonContent [routerLink]="['/devices/setup']">
              <sbnb-button [fullWidth]="true">Connect a device account</sbnb-button>
            </a>
          </sbnb-device-upsell-button>
        </div>
      </div>

      <img
        class="devices-intro-img"
        fxFlex="0 0 auto"
        fxFlexOrder.lt-md="1"
        src="/assets/images/demo/devices/devices-intro.png"
        alt="Supported device providers" />
    </div>

    <picture>
      <img fxHide.lt-md src="assets/images/demo/devices/devices.png" class="demo-ux-image" />
      <img
        fxHide
        fxShow.lt-md
        src="assets/images/demo/devices/devices-mobile.png"
        class="demo-ux-image demo-ux-image-mobile" />
    </picture>
  </main>
</div>

<ng-template #loadingTemplate>
  <div fxFlex>
    <sbnb-loading-spinner></sbnb-loading-spinner>
  </div>
</ng-template>
